<template>
  <div>
    <b-modal
      @hide="fecharModal"
      v-model="isVisivel"
      id="modalDownloadSuite"
      ref="modal-download-suite"
      title="Download do Suite Klaus"
      hide-footer
      centered
    >
      <p class="my-4 text-center">
        Declaro que li e concordo com os
        <a
          target="_blank"
          href="https://klausfiscal.com.br/termo-de-uso-e-politica-de-privacidade/"
        >
          termos de uso e privacidade
        </a>
        da Suíte Klaus.
      </p>

      <div class="w-75 mx-auto d-flex justify-content-around">
        <b-button variant="link" @click="fecharModal"> Cancelar </b-button>

        <b-button class="px-4 py-2" @click="downloadSuite" variant="primary"
          >Continuar</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "ModalDownloadSuite",
  props: { visibilidade: { type: Boolean, default: false } },
  data() {
    return {
      isVisivel: false,
    };
  },
  watch: {
    visibilidade(valor) {
      this.isVisivel = valor;
    },
  },
  methods: {
    fecharModal() {
      this.$emit("fechar-modal");
    },
    downloadSuite() {
      window.open(
        "https://klausfiscal.blob.core.windows.net/suite-klaus-container/suite-klaus-win-x32.exe",
        "_blank"
      );
    },
  },
};
</script>

<style scoped>
p {
  font-size: 1.1rem;
}
</style>